module.exports = __webpack_public_path__ + "static/bg-11-529e319e287fb75a116e7f60f361cdf8.jpg";